import Axios from "axios";

const INITIAL_STATE = {
  files: {
    total: 0,
    perPage: 0,
    page: 0,
    lastPage: 0,
    data: [
      {
        id: null,
        name: null,
        file_path: null,
      },
    ],
  },
};

export const updateFiles = param => ({
  type: "SET_FILES",
  payload: param,
});

export const getFiles = (url, config) => (dispatch, getState) => {
  return Axios.get(url, config)
    .then(resp => {
      dispatch(updateFiles(resp.data));
    })
    .catch(function (error) {});
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SET_FILES":
      return { ...state, files: action.payload };
    default:
      return state;
  }
};
